import React, { createRef, useEffect, useRef, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Intro from '../components/sections/Intro';
import What from '../components/sections/What';
import Usecases from '../components/sections/Usecases';
import Demo from '../components/sections/Demo';
import Docs from '../components/sections/Docs';
import LearnMore from '../components/sections/LearnMore';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
    },
}))

export default function NanoMeetLandingPage(props) {
    const classes = useStyles();
    const urlParams = new URLSearchParams(window.location.search);
    const demoRef = useRef(null);
    const whatRef = useRef(null);
    const [requestDemo, setRequestDemo] = useState(false);

    const scrollTo = (id) => () => {
        switch (id) {
            case "demo":
                demoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setRequestDemo(true);
                break;
            case "what":
                whatRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                break;
            default: break;
        }
    }

    useEffect(() => {
        const demo = urlParams.get('demo')
        console.log(demo !== null)
        if (demo !== null) {
            demoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setRequestDemo(true);
        }
    }, [])

    return (
        <div className={classes.root}>
            <Intro clickedDemo={scrollTo("demo")} clickedGettingStarted={scrollTo("what")} />
            <div ref={whatRef}>
                <What />
            </div>
            <Usecases />
            <div ref={demoRef}>
                <Demo start={requestDemo} />
            </div>
            <Docs />
            <LearnMore />
        </div>
    )
}